module.exports = __webpack_public_path__ + "static/media/vap-homes-sprite.6107b7b9.svg";